import { rewriteSlugs } from './rewrite-rules'

export const RewriteSlugs = rewriteSlugs
